import { render, staticRenderFns } from "./Stocks.vue?vue&type=template&id=5008031c&scoped=true&"
import script from "./Stocks.vue?vue&type=script&lang=ts&"
export * from "./Stocks.vue?vue&type=script&lang=ts&"
import style0 from "./Stocks.vue?vue&type=style&index=0&id=5008031c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008031c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
